/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileAttachment
 */
export interface FileAttachment {
    /**
     * Unique identifier of the attachment
     * @type {number}
     * @memberof FileAttachment
     */
    id: number;
    /**
     * Name of the file
     * @type {string}
     * @memberof FileAttachment
     */
    name: string;
    /**
     * MIME type of the file
     * @type {string}
     * @memberof FileAttachment
     */
    mimetype: string;
    /**
     * Size of the file in bytes
     * @type {number}
     * @memberof FileAttachment
     */
    fileSize: number;
    /**
     * Date when the file was created
     * @type {string}
     * @memberof FileAttachment
     */
    createDate: string;
    /**
     * Data of the file in base64 format
     * @type {string}
     * @memberof FileAttachment
     */
    datas: string;
}

/**
 * Check if a given object implements the FileAttachment interface.
 */
export function instanceOfFileAttachment(value: object): value is FileAttachment {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('mimetype' in value) || value['mimetype'] === undefined) return false;
    if (!('fileSize' in value) || value['fileSize'] === undefined) return false;
    if (!('createDate' in value) || value['createDate'] === undefined) return false;
    if (!('datas' in value) || value['datas'] === undefined) return false;
    return true;
}

export function FileAttachmentFromJSON(json: any): FileAttachment {
    return FileAttachmentFromJSONTyped(json, false);
}

export function FileAttachmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileAttachment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'mimetype': json['mimetype'],
        'fileSize': json['file_size'],
        'createDate': json['create_date'],
        'datas': json['datas'],
    };
}

export function FileAttachmentToJSON(json: any): FileAttachment {
    return FileAttachmentToJSONTyped(json, false);
}

export function FileAttachmentToJSONTyped(value?: FileAttachment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'mimetype': value['mimetype'],
        'file_size': value['fileSize'],
        'create_date': value['createDate'],
        'datas': value['datas'],
    };
}

